import React, { useEffect, useState } from 'react';
import { ConsentEmailCard } from '../components';
import EmptyState from '../shared/empty_state';
import ToggleWarningModal from '../shared/toggle_warning_modal';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card'. 'node_modules/@grnhse/seedling/lib/azalea/components/card.js' implicitly has an 'any' type.
import { CardHeader } from '@grnhse/seedling/lib/azalea/components/card';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/modals/use_modal'. 'node_modules/@grnhse/seedling/lib/azalea/components/modals/use_modal.js' implicitly has an 'any' type.
import useModal from '@grnhse/seedling/lib/azalea/components/modals/use_modal';
import { SecondaryBodyText } from '@grnhse/seedling/lib/azalea/typography';
import Toggle from '@grnhse/seedling/lib/azalea/components/toggle';
import t from 'shared/utils/translation';
import styled from 'styled-components';
// @ts-expect-error - TS7016 - Could not find a declaration file for module './configure_extension_action'. 'app/webpack/javascripts/gdpr/components/consent_extension_emails/configure_extension_action.js' implicitly has an 'any' type.
import { ConfigureExtensionAction } from './configure_extension_action';
import { hasConsentExtensionEmailData } from './has_consent_extension_email_data';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
import { getCardGutter } from '../shared/card';

type ReadOnlyViewProps = {
  consentPeriod: number;
  setErrors: any;
  setIsEditing: any;
  consentEmailEnabled: boolean;
  setConsentEmailEnabled: any;
  saveConsentEmailEnabled: any;
};

export function ReadOnlyView({
  consentPeriod,
  setErrors,
  setIsEditing,
  consentEmailEnabled,
  setConsentEmailEnabled,
  saveConsentEmailEnabled,
}: ReadOnlyViewProps) {
  return (
    <div
      data-provides="gdpr_consent_extension_email"
      className="gdpr-consent-extension-email"
    >
      <CardHeader
        label={t('gdpr.consent_extension_email.title')}
        labelSize="large"
        rightComponent={
          <ConfigureExtensionAction
            // @ts-expect-error - TS7006 - Parameter 'isEditing' implicitly has an 'any' type.
            setIsEditing={(isEditing) => {
              setErrors([]);
              setIsEditing(isEditing);
            }}
          />
        }
      />
      <ConsentEmailCard
        verticalCardGutter="medium"
        cardGutter={getCardGutter(false)}
      >
        {hasConsentExtensionEmailData(consentPeriod) ? (
          <ConfiguredExtension
            consentPeriod={consentPeriod}
            saveConsentEmailEnabled={saveConsentEmailEnabled}
            consentEmailEnabled={consentEmailEnabled}
            setConsentEmailEnabled={setConsentEmailEnabled}
            setErrors={setErrors}
            setIsEditing={setIsEditing}
          />
        ) : (
          <NoConfiguredPeriod />
        )}
      </ConsentEmailCard>
    </div>
  );
}

function NoConfiguredPeriod() {
  return (
    <React.Fragment>
      <SecondaryBodyText>
        {t('gdpr.consent_extension_email.description')}
      </SecondaryBodyText>
      {/* @ts-expect-error - TS2769 - No overload matches this call. */}
      <EmptyState emphasize data-provides="no_retention_rules_message">
        {t('gdpr.consent_extension_email.no_configuration')}
      </EmptyState>
    </React.Fragment>
  );
}

type ConfiguredExtensionProps = {
  consentPeriod: number;
  consentEmailEnabled: boolean;
  saveConsentEmailEnabled: any;
  setConsentEmailEnabled: any;
  setErrors: any;
  setIsEditing: any;
};

export function ConfiguredExtension({
  consentPeriod,
  consentEmailEnabled,
  saveConsentEmailEnabled,
  setConsentEmailEnabled,
  setErrors,
  setIsEditing,
}: ConfiguredExtensionProps) {
  const [isModalOpen, openModal, closeModal] = useModal(false);
  const [closingModalWithEdit, setClosingModalWithEdit] = useState(false);

  // This callback is required to close the modal before switching to the Edit component
  useEffect(() => {
    if (closingModalWithEdit) {
      setIsEditing(true);
    }
  }, [closingModalWithEdit, setIsEditing]);

  const informationMessage = t(
    'gdpr.consent_extension_email.configured_information',
    { count: +consentPeriod }
  );

  return (
    <React.Fragment>
      <ConfiguredInformation>
        <ToggleWarningModal
          isOpen={isModalOpen}
          onCancel={closeModal}
          onConfirm={() => {
            closeModal();
            setClosingModalWithEdit(true);
          }}
          buttonText={t(
            'gdpr.consent_extension_email.invalid_modal.button_text'
          )}
          text={t('gdpr.consent_extension_email.invalid_modal.text')}
          title={t('gdpr.consent_extension_email.invalid_modal.title')}
        />
        <StyledToggle
          data-provides="consent_extension_email_toggle"
          enabled={consentEmailEnabled}
          onClick={() => {
            const newState = !consentEmailEnabled;
            setConsentEmailEnabled(newState);
            // @ts-expect-error - TS7031 - Binding element 'response' implicitly has an 'any' type.
            saveConsentEmailEnabled(newState).catch(({ response }) => {
              setConsentEmailEnabled(!newState);
              setErrors(response.data.errors);
              openModal();
            });
          }}
        />
        {/* @ts-expect-error - TS2769 - No overload matches this call. */}
        <ConfiguredPeriodDays enabled={consentEmailEnabled}>
          {informationMessage}
        </ConfiguredPeriodDays>
      </ConfiguredInformation>
    </React.Fragment>
  );
}

const StyledToggle = styled(Toggle)`
  min-width: 50px;
`;

export const Description = styled.span``;

export const ConfiguredPeriodDays = styled.span`
  ${/* @ts-expect-error */ ''}
  color: ${(props) => (props.enabled ? colors.darkestGrey : colors.mediumGrey)};
  font-size: 14px;
  font-weight: 400;
  margin-left: 24.1px;
`;

export const ConfiguredInformation = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 3px;
  margin-bottom: 1.5px;
  margin-top: -3.5px;
`;
